import { Paper, Skeleton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { useTranslation } from "react-i18next";
import theme from "../../style/theme";
import { decimalToString } from "../../utils/toString";
import i18n from "../../i18n";
import { getStateColor, stateOptions, stateStripeOpt } from "../../utils/state-opt";
import { TableCustomer, TablePaymentMethod } from "./loadingData";
import { Timestamp } from "firebase/firestore";

export function OverviewTable({balances}) {
    const { t } = useTranslation();

    return <div style={{margin: '5px 5px 0 5px'}}>
        <TableContainer component={Paper}>
            <Table aria-label="mails-table">
                <TableHead>
                    <TableRow sx={{backgroundColor: theme.palette.primary.main}}>
                        <TableCell sx={{color: 'white', fontWeight: 'bold'}}>{t('balance.tables.overviwe.amount')}</TableCell>
                        <TableCell sx={{color: 'white', fontWeight: 'bold'}}>{t('balance.tables.overviwe.method')}</TableCell>
                        <TableCell sx={{color: 'white', fontWeight: 'bold'}}>{t('balance.tables.overviwe.description')}</TableCell>
                        <TableCell sx={{color: 'white', fontWeight: 'bold'}}>{t('balance.tables.overviwe.customer')}</TableCell>
                        <TableCell sx={{color: 'white', fontWeight: 'bold'}}>{t('balance.tables.overviwe.date')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {balances.map((payment, index) => <TableRow key={index} className="hover-color clickable">
                        <TableCell>{`${decimalToString(payment.getAmount()/100, i18n.resolvedLanguage??'es', 2)} €`} <span className={getStateColor(payment.getStatus())}>{stateOptions(t)[stateStripeOpt.indexOf(payment.getStatus())]}</span></TableCell>
                        <TableCell>{payment.getPaymentMethod() !== null && payment.getPaymentMethod() !== undefined ? <TablePaymentMethod id={payment.getPaymentMethod()} customerId={payment.getCustomer()}/> : t('customers.noMethod')}</TableCell>
                        <TableCell>{payment.getDescription()}</TableCell>
                        <TableCell>{payment.getCustomer() !== null && payment.getCustomer() !== undefined && payment.getCustomer().length > 0 ? <TableCustomer id={payment.getCustomer()}/> : t('customers.noCustomer')}</TableCell>
                        <TableCell>{payment.getCreated().toDate().toLocaleDateString(i18n.resolvedLanguage??'es')}</TableCell>
                    </TableRow>)}
                </TableBody>
            </Table>
        </TableContainer>
    </div>;
}

export function OverviewLoadingTable({rows}) {
    const { t } = useTranslation();

    return <div style={{margin: '5px'}}>
        <TableContainer component={Paper}>
            <Table aria-label="mails-table">
                <TableHead>
                    <TableRow sx={{backgroundColor: theme.palette.primary.main}}>
                        <TableCell sx={{color: 'white', fontWeight: 'bold'}}>{t('balance.tables.overviwe.amount')}</TableCell>
                        <TableCell sx={{color: 'white', fontWeight: 'bold'}}>{t('balance.tables.overviwe.method')}</TableCell>
                        <TableCell sx={{color: 'white', fontWeight: 'bold'}}>{t('balance.tables.overviwe.description')}</TableCell>
                        <TableCell sx={{color: 'white', fontWeight: 'bold'}}>{t('balance.tables.overviwe.customer')}</TableCell>
                        <TableCell sx={{color: 'white', fontWeight: 'bold'}}>{t('balance.tables.overviwe.date')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {[...Array(rows)].map((_, index) => <TableRow key={index}>
                        <TableCell component="th" scope="row"><Skeleton variant="text"/></TableCell>
                        <TableCell component="th" scope="row"><Skeleton variant="text"/></TableCell>
                        <TableCell component="th" scope="row"><Skeleton variant="text"/></TableCell>
                        <TableCell component="th" scope="row"><Skeleton variant="text"/></TableCell>
                        <TableCell component="th" scope="row"><Skeleton variant="text"/></TableCell>
                    </TableRow>)}
                </TableBody>
            </Table>
        </TableContainer>
    </div>;
}